<page-heading
  [title]="'shared.settingsAttendance.pageTitle' | translate"
  [description]="'shared.settingsAttendance.pageDescription' | translate"
/>

@if (channel) {
  <div class="w-100 overflow-hidden h-100">
    <form [formGroup]="formGroup" class="d-flex gap-4 w-100">

      <div class="d-flex mt-3 w-50">
        <div class="d-flex flex-column mt-3 w-100 gap-2">

          <div class="w-100 border rounded p-2 d-flex flex-column">

            <div class="custom-switch --dropdown-fields mb-2 d-flex">
              <div>
                <input 
                  type="checkbox" 
                  id="limitAttendancePerAttendant" 
                  data-switch="success" 
                  formControlName="limitAttendancePerAttendant"
                  tabindex="0"
                  (change)="changeLimitAttendancePerAttendant()"
                />
                <label for="limitAttendancePerAttendant"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                    <strong>{{ 'shared.settingsAttendance.limitAttendancePerAttendantTitle' | translate }}</strong>
                    <small>{{ 'shared.settingsAttendance.limitAttendancePerAttendantDescription' | translate }}</small>
                  </span>
              </label>
            </div>

            @if (formGroup.get('limitAttendancePerAttendant')?.value === true) {
            <div class="mt-4 d-flex w-100 gap-2">
              <div class="d-flex flex-column w-100">
                <label class="fw-medium w-100">{{ 'shared.settingsAttendance.maxNumberAttendanceAttendantLabel' | translate }}</label>
                <input class="form-control" maxlength="3" formControlName="maxNumberAttendanceAttendant" [mask]="'0*'">
              </div>
            </div>
            }
          </div>

          <div class="d-flex flex-column gap-2 w-100">
            <div class="w-100 border rounded p-2 d-flex flex-column">

              <div class="custom-switch --dropdown-fields mb-2 pb-2">
                <div>
                  <input 
                    type="checkbox" 
                    id="sendResponseInactivy" 
                    data-switch="success" 
                    formControlName="sendResponseInactivy"
                    tabindex="0"
                  />
                  <label for="sendResponseInactivy"></label>
                </div>
                <label class="custom-switch-label">
                  <span>
                    <strong>{{ 'shared.settingsAttendance.inactivityMessageTitle' | translate }}</strong>
                    <small>{{ 'shared.settingsAttendance.inactivityMessageDescription' | translate }}</small>
                  </span>
                </label>
              </div>

              @if (formGroup.get('sendResponseInactivy').value === true) {
              <div class="mt-4 d-flex align-items-center w-100 gap-3">
                <div class="d-flex flex-column w-50">
                  <label class="fw-medium w-100">{{ 'shared.settingsAttendance.enterQuantityLabel' | translate }}</label>
                  <input class="form-control" maxlength="2" formControlName="sendResponseAfterPeriod" [mask]="'0*'">
                </div>
                <div class="d-flex flex-column w-50">
                  <label class="fw-medium w-100">{{ 'shared.settingsAttendance.selectPeriodLabel' | translate }}</label>
                  <mat-select class="form-control" [value]="selectedOptions"
                    (selectionChange)="changeSelectOptionsInactivy($event)">
                    <mat-option [value]="'daySendResponse'">{{ 'shared.settingsAttendance.periodDay' | translate }}</mat-option>
                    <mat-option [value]="'hourSendResponse'">{{ 'shared.settingsAttendance.periodHour' | translate }}</mat-option>
                    <mat-option [value]="'minutesSendResponse'">{{ 'shared.settingsAttendance.periodMinute' | translate }}</mat-option>
                  </mat-select>
                </div>
              </div>
              }
            </div>

            <div class="w-100 border rounded p-2 d-flex flex-column">

              <div class="custom-switch --dropdown-fields mb-2 pb-2">
                <div>
                  <input 
                    type="checkbox" 
                    id="autoAttendanceInactivy" 
                    data-switch="success" 
                    formControlName="autoAttendanceInactivy"
                    tabindex="0"
                    (change)="changeIsAttendanceInactive('autoAttendanceInactivy')"
                  />
                  <label for="autoAttendanceInactivy"></label>
                </div>
                <label class="custom-switch-label">
                  <span>
                    <strong>{{ 'shared.settingsAttendance.autoServiceInactivityMessageTitle' | translate }}</strong>
                    <small>{{ 'shared.settingsAttendance.autoServiceInactivityMessageDescription' | translate }}</small>
                  </span>
                </label>
              </div>
              

              @if (formGroup.get('autoAttendanceInactivy').value === true) {
              <div class="d-flex flex-column w-100 mt-3">
                <label class="fw-medium">{{ 'shared.settingsAttendance.timeInMinutesLabel' | translate }}</label>
                <input class="form-control" formControlName="autoAfterPeriod" [mask]="'0*'">
              </div>
              <div class="d-flex flex-column w-100 mt-3">
                <label class="fw-medium">{{ 'shared.settingsAttendance.amountAttemptedResponseLabel' | translate }}</label>
                <input class="form-control" formControlName="amountAttemptedResponse" [mask]="'0*'">
              </div>
              <div class="d-flex flex-column w-100 mt-3">

                <div class="custom-switch --dropdown-fields mb-2 pb-2">
                  <div>
                    <input 
                      type="checkbox" 
                      id="finishAttendanceAfterAttemptedResponse" 
                      data-switch="success" 
                      formControlName="finishAttendanceAfterAttemptedResponse"
                      tabindex="0"
                    />
                    <label for="finishAttendanceAfterAttemptedResponse"></label>
                  </div>
                  <label class="custom-switch-label">
                    <span>
                      <strong>{{ 'shared.settingsAttendance.finishAttendanceTitle' | translate }}</strong>
                      <small>{{ 'shared.settingsAttendance.finishAttendanceDescription' | translate }}</small>
                    </span>
                  </label>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex mt-3 w-50">
        <div class="d-flex flex-column mt-3 w-100 gap-2">

          <div class="w-100 border rounded p-2 d-flex flex-column">

            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input 
                  type="checkbox" 
                  id="isAttendanceInactive" 
                  data-switch="success" 
                  formControlName="isAttendanceInactive"
                  tabindex="0"
                  [checked]="!isInactivityChatbot"
                  (change)="changeIsAttendanceInactive('isAttendanceInactive')"
                />
                <label for="isAttendanceInactive"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>{{ 'shared.settingsAttendance.transferByInactivityTitle' | translate }}</strong>
                  <small>{{ 'shared.settingsAttendance.transferByInactivityDescription' | translate }}</small>
                </span>
              </label>
            </div>

            @if (formGroup.get('isAttendanceInactive').value === true) {
            <div class="w-100 d-flex flex-column p-2">
              <div class="d-flex flex-column w-100 mt-3">
                <label class="fw-medium w-100">{{ 'shared.settingsAttendance.transferAfterMinutesLabel' | translate }}</label>
                <input class="form-control" maxlength="3" formControlName="minutesTransferAttendance" [mask]="'0*'">
              </div>
              <div class="d-flex flex-column w-100 mt-3">
                <label class="fw-medium w-100">{{ 'shared.settingsAttendance.departmentLabel' | translate }}</label>
                <mat-select class="form-control" formControlName="tranferTo" [placeholder]="'shared.settingsAttendance.selectPlaceholder' | translate">
                  <div class="p-2 mb-2">
                    <input class="form-control" type="text" (focus)="onFocusTransferTo()"
                      [formControl]="filterControlDepartmentToTransfer" [placeholder]="'shared.settingsAttendance.searchDepartmentPlaceholder' | translate">
                  </div>
                  @for (item of listDepartmentToTransfer; track item) {
                  <mat-option [value]="item._id">{{item.name}}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            }
          </div>

          <div class="w-100 border rounded p-2 d-flex flex-column">

            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input 
                  type="checkbox" 
                  id="closeAttendanceInactive" 
                  data-switch="success" 
                  formControlName="closeAttendanceInactive"
                  tabindex="0"
                  (change)="changeCloseAttendanceInactive()"
                />
                <label for="closeAttendanceInactive"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>{{ 'shared.settingsAttendance.closeByInactivityTitle' | translate }}</strong>
                  <small>{{ 'shared.settingsAttendance.closeByInactivityDescription' | translate }}</small>
                </span>
              </label>
            </div>

            @if (formGroup.get('closeAttendanceInactive')?.value === true) {
            <div class="w-100 d-flex flex-column p-2">
              <div class="d-flex flex-column w-100 mt-3">
                <label class="fw-medium">{{ 'shared.settingsAttendance.finishConversationAfterMinutesLabel' | translate }}</label>
                <input class="form-control" formControlName="minutesFinishAttendance" [mask]="'0*'">
              </div>
            </div>
            }
          </div>

          <div class="w-100 border rounded p-2 d-flex flex-column">
            <h4 class="p-0 m-0">{{ 'shared.settingsAttendance.distributionLogicTitle' | translate }}</h4>
            <p class="text-secondary fw-regular w-100 mb-2">
              {{ 'shared.settingsAttendance.distributionLogicDescription' | translate }}
            </p>

            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input 
                  type="checkbox" 
                  id="FIRST_ASSUME" 
                  data-switch="success" 
                  tabindex="0"
                  [checked]="formGroup.get('typeDistribution').value === 'FIRST_ASSUME'"
                  (change)="onListaToggle($event)"
                />
                <label for="FIRST_ASSUME"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>{{ 'shared.settingsAttendance.firstAvailableAttendantTitle' | translate }}</strong>
                  <small>{{ 'shared.settingsAttendance.firstAvailableAttendantDescription' | translate }}</small>
                </span>
              </label>
            </div>

            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input 
                  type="checkbox" 
                  id="LESS_ACTIVE_CONVERSATION" 
                  data-switch="success" 
                  tabindex="0"
                  [checked]="formGroup.get('typeDistribution').value === 'LESS_ACTIVE_CONVERSATION'"
                  (change)="onDistribuitionToggle($event)"
                />
                <label for="LESS_ACTIVE_CONVERSATION"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>{{ 'shared.settingsAttendance.lessActiveConversationsTitle' | translate }}</strong>
                  <small>{{ 'shared.settingsAttendance.lessActiveConversationsDescription' | translate }}</small>
                </span>
              </label>
            </div>
            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input 
                  type="checkbox" 
                  id="ALPHABETICAL_ORDER" 
                  data-switch="success" 
                  tabindex="0"
                  [checked]="formGroup.get('typeDistribution').value === 'ALPHABETICAL_ORDER'"
                  (change)="onAlphabeticalOrderToggle($event)"
                />
                <label  for="ALPHABETICAL_ORDER"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>{{ 'shared.settingsAttendance.alphabeticalOrderTitle' | translate }}</strong>
                  <small>{{ 'shared.settingsAttendance.alphabeticalOrderDescription' | translate }}</small>
                </span>
              </label>
            </div>

            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input 
                  type="checkbox" 
                  id="distributionForOnlineUsers" 
                  data-switch="success" 
                  formControlName="distributionForOnlineUsers"
                  tabindex="0"
                  [checked]="formGroup.get('distributionForOnlineUsers').value"
                  (change)="onDistributionForOnlineUsers($event)"
                />
                <label for="distributionForOnlineUsers"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>{{ 'shared.settingsAttendance.onlineAttendantsTitle' | translate }}</strong>
                  <small>{{ 'shared.settingsAttendance.onlineAttendantsDescription' | translate }}</small>
                </span>
              </label>
            </div>

            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input 
                  type="checkbox" 
                  id="distributionForOvertimeAttendance" 
                  data-switch="success" 
                  formControlName="distributionForOvertimeAttendance"
                  tabindex="0"
                  [checked]="formGroup.get('distributionForOvertimeAttendance').value"
                  (change)="onDistributionForOvertimeAttendance($event)"
                />
                <label for="distributionForOvertimeAttendance"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>{{ 'shared.settingsAttendance.applyOvertimeAttendanceTitle' | translate }}</strong>
                  <small>{{ 'shared.settingsAttendance.applyOvertimeAttendanceDescription' | translate }}</small>
                </span>
              </label>
            </div>

          </div>
        </div>
      </div>

      <div class="d-flex mt-3 w-50">
        <div class="d-flex flex-column mt-3 w-100 gap-2">

          <div class="w-100 border rounded p-2 d-flex flex-column">
            <h5 class="p-0 m-0">{{ 'shared.settingsAttendance.defaultDepartmentTitle' | translate }}</h5>
            <p class="text-secondary fw-regular w-100 mb-2">
              {{ 'shared.settingsAttendance.defaultDepartmentDescription' | translate }}
            </p>
            <mat-select
              class="form-control"
              formControlName="departmentDefault"
              [placeholder]="'shared.settingsAttendance.selectPlaceholder' | translate"
            >
              <div class="p-2 mb-2">
                <input class="form-control" type="text" (focus)="onFocusDepartmentDefault()"
                  [formControl]="filterControlDepartmentDefault" [placeholder]="'shared.settingsAttendance.searchDepartmentPlaceholder' | translate">
              </div>
              @for (item of listDepartmentToDefault; track item) {
              <mat-option [value]="item._id">{{item.name}}</mat-option>
              }
            </mat-select>
          </div>

          <div class="w-100 border rounded p-2 d-flex flex-column">
            <h5 class="p-0 m-0">{{ 'shared.settingsAttendance.irrelevanceFiltersTitle' | translate }}</h5>
            <p class="text-secondary fw-regular w-100 mb-2">
              {{ 'shared.settingsAttendance.irrelevanceFiltersDescription' | translate }}
            </p>
            <button class="btn btn-primary fw-bold"
              (click)="addFilterIrrelevantMessages()">
              {{ 'shared.settingsAttendance.addIrrelevanceFilterButton' | translate }}
            </button>
          </div>

          @if (getModuleFlow()) {
          <div class="w-100 border rounded p-2 d-flex flex-column">

            <div class="custom-switch --dropdown-fields mb-2 pb-2">
              <div>
                <input
                  type="checkbox"
                  id="activeFlowModule"
                  data-switch="success"
                  tabindex="0"
                  [checked]="activeFlowModule"
                  (change)="onActiveFlowModuleToggle($event)"
                />
                <label for="activeFlowModule"></label>
              </div>
              <label class="custom-switch-label">
                <span>
                  <strong>Fluxo de Atendimento</strong>
                  <small>Conduza os atendimentos deste canal por um fluxo publicado</small>
                </span>
              </label>
            </div>

            @if (activeFlowModule) {
            <div class="d-flex flex-column w-100 mt-3">
              <label class="fw-medium w-100">Fluxo</label>
              <mat-select class="form-control" [value]="flow" placeholder="Selecione um fluxo"
                (selectionChange)="changeSelectedFlow($event)">
                @for (f of flows; track f._id) {
                <mat-option [value]="f._id">{{f.name}}</mat-option>
                }
              </mat-select>
              @if (flowsError) {
              <small class="text-danger mt-1">{{ flowsError }}</small>
              } @else if (!flow) {
              <small class="text-danger mt-1">Selecione um fluxo para ativar.</small>
              }
            </div>
            }
          </div>
          }
        </div>
      </div>
    </form>
  </div>

<hr class="mt-4"/>

<div class="row mt-4">
  <div class="col-12 gap-2 d-flex justify-content-end pb-4">
      @if (isAdmin()) {
        <button class="btn btn-success" [disabled]="loading" cdkFocusInitial (click)="onConfirmClick()">
          {{ !loading ? ('shared.settingsAttendance.saveButton' | translate) : "" }}
          @if (loading) {
            <mat-spinner [diameter]="15" [color]="'accent'" mode="indeterminate" />
          }
        </button>
      }
    </div>
  </div>
}